"use client";

import { Toaster as Sonner, ToasterProps } from "sonner";
import { useTheme } from "@/shared/providers/ThemeProvider";

const Toaster = ({ ...props }: ToasterProps) => {
  const { resolvedTheme } = useTheme();

  return (
    <Sonner
      theme={resolvedTheme as ToasterProps["theme"]}
      className="toaster group"
      position="bottom-right"
      toastOptions={{
        classNames: {
          toast: 'bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 border border-gray-200 dark:border-gray-700 shadow-lg rounded-xl',
          title: 'text-gray-900 dark:text-gray-100 font-medium',
          description: 'text-gray-600 dark:text-gray-400 text-sm',
          actionButton: 'bg-[var(--brand-primary)] text-white hover:bg-[var(--brand-primary-hover)] rounded-lg px-3 py-1.5 text-sm font-medium',
          cancelButton: 'bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 rounded-lg px-3 py-1.5 text-sm',
          success: 'border-green-200 dark:border-green-800',
          error: 'border-red-200 dark:border-red-800',
          warning: 'border-yellow-200 dark:border-yellow-800',
          info: 'border-blue-200 dark:border-blue-800',
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
